export default "__VITE_ASSET__Bx4ROFI5__"